module.exports = __webpack_public_path__ + "static/media/OrthoInactive.ec462c74.png";